import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "TextFooterModule",
    component: () => (__SERVER__ ? require("./text-footer-module-view") : import("./text-footer-module-view"))
});

export default definition;
